// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/views/partner/crud/gallery/add/details/details.css
// module id = 3132
// module chunks = 0